import { RESEND_EMAIL_DELAY } from '@/login/components/activation/activation-constants';
import { IconGeneric } from '@/widgets/components/icon';
import { Input } from '@/widgets/components/input';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import EmailSent from '@/../img/email-sent.svg';
import RentalscapeLogo from '../../../favicon-apple-touch-144.png';
import { Button, InputGroup } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

export const StyledRentalscapeLogo = styled.img.attrs({ src: RentalscapeLogo })`
  height: 51px;
  width: 51px;
  margin-bottom: 10px;
`;

// BEGIN: Placeholder styles to test out SSO functionality
export const StyledSSOWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledSSOSpacer = styled.div`
  margin-top: 24px;
`;

export const StyledSSOButton = styled(Button)`
  width: 300px;
  margin-top: 18px;
  &.rs-btn-default {
    color: #ffffff;
    background-color: ${cssVars.color.rentalscapeBlue};
  }
`;

export const StyledForgotPasswordButton = styled(InvisibleButton)`
  color: #101938;
  transition: color 0.2s ease-in;
  :hover {
    color: ${cssVars.color.rentalscapeBlue};
  }
`;

export const StyledEmailSentLogo = styled(EmailSent)`
  height: 74px;
  width: 72px;
  margin-top: 12px;
  margin-bottom: 18px;
`;

export const StyledInputCloseIcon = styled(IconGeneric)`
  color: rgba(0, 0, 0, 0.6);
`;

export const InputCloseWrapper = styled.div`
  width: 300px;
  .rs-btn.rs-btn-default.rs-input-group-btn {
    padding: 9px 11px !important;
  }
`;

export const StyledInputGroup = styled(InputGroup)`
  &.rs-input-group.rs-input-group-inside .rs-input-group-btn {
    padding: 9px 11px;
  }
  &.rs-input-group.rs-input-group-inside .rs-input-group-btn:last-child {
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
  }
`;

export const InputErrorText = styled.div`
  width: 300px;
  line-height: 1.43;
  font-size: 12px;
  color: red;

  ::before {
    content: '${(props) => props.text}';
  }
`;

export const DisclaimerTextWrapper = styled.div`
  width: 300px;
  height: 60px;
  margin-bottom: 36px;
  font-size: 12px;
  line-height: 1.67;
  color: rgba(0, 0, 0, 0.5);
  ::before {
    content: 'By clicking “Continue”, you acknowledge that you have read and understood, and agree to Terms & Conditions and Privacy Policy.';
  }
`;

export const RentalscapeTitle = styled.div`
  color: ${cssVars.color.rentalscapeBlue};
  font-size: 23px;
  font-weight: 700;
  line-height: 0.8;

  ::before {
    content: 'rentalscape';
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: ${(props) =>
    props.paddingBottom ? props.paddingBottom : '30px'};
`;

export const PoweredByDeckard = styled.div`
  padding-top: 3px;
  font-size: 12px;
  ::before {
    content: 'Powered by Deckard';
  }
`;

export const ContainerFooterWrapper = styled.div`
  width: 400px;
  height: 68px;
  background-color: rgba(89, 126, 247, 0.1);
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  transform: ${(props) => (props.hideSignIn ? 'rotateY(180deg)' : '')};
  /* opacity: .1; */
  transition: background-color 0.4s ease-in;
  :hover {
    background-color: rgba(89, 126, 247, 0.3);
  }
`;

export const StyledFooterButtonText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${cssVars.color.rentalscapeBlue};
  animation: ${(props) => (props.rotating ? 'fade-out-in 1s' : '')};
  @keyframes fade-out-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  cursor: pointer;
  ::before {
    content: ${(props) => `${props.buttonText}`};
  }
`;

export const StyledInput = styled(Input)`
  width: 300px;
  padding-right: 0px;
  border-color: ${(props) => (props.error ? 'rgba(255, 0, 0, .5)' : '')};
`;

export const StyledText = styled.div`
  font-size: 14px;
  line-height: 1;
  padding: ${(props) => props.padding || '0px 0px 8px 0px'};
  font-weight: ${(props) => (props.bold ? '600' : '')};
  color: #101938;
  ::before {
    content: ${(props) => `${props.text}`};
  }
`;

export const CheckboxWithTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const StyledFormSubmitButton = styled(Button)`
  width: 300px;
  margin-bottom: 18px;
  &.rs-btn-default {
    color: #ffffff;
    background-color: ${cssVars.color.rentalscapeBlue};
  }
`;

export const ResendEmailButton = styled(StyledFormSubmitButton)`
  &.rs-btn-default {
    background-color: rgba(16, 25, 56, 0.05);
    color: #979aa2;
    animation: seconds 0s ease-in ${RESEND_EMAIL_DELAY}s forwards;
    pointer-events: none;
  }
  @keyframes seconds {
    0% {
      background-color: rgba(16, 25, 56, 0.05);
      color: #979aa2;
      pointer-events: disabled;
    }
    100% {
      background-color: ${cssVars.color.rentalscapeBlue};
      color: white;
      pointer-events: inherit;
    }
  }
`;

export const CheckboxForgotPasswordWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  padding-bottom: 10px;
  margin-top: 16px;
`;

export const SignupFormAnimationWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.2s linear;
  opacity: ${(props) => (props.authFadeOut ? '1' : '0')};
  z-index: ${(props) => (props.showOtherForm ? '' : '100')};
  padding-bottom: 70px;
  width: 100%;
`;

export const OtherFormAnimationWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  transform: rotateY(180deg);
  opacity: ${(props) => (props.signInFadeOut ? '1' : '0')};
  transition: opacity 0.2s linear;
  z-index: ${(props) => (props.showOtherForm ? '100' : '')};
  width: 100%;
  top: 0;
`;

export const FormContainer = styled.div`
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  width: 400px;
  justify-content: flex-start;
  padding-top: 20px;
  align-items: center;
  box-shadow:
    0 2px 20px 0 rgba(89, 126, 247, 0.06),
    0 2px 12px 0 rgba(89, 126, 247, 0.03),
    0 2px 8px 0 rgba(8, 10, 37, 0.05);
  transition:
    transform 0.4s ease-in,
    height 0.5s ease-out;
  height: ${(props) => (props.height ? props.height : '525px')};
  transform: ${(props) => (props.hideSignIn ? 'rotateY(180deg)' : '')};
`;
